module.exports = __webpack_public_path__ + "4dc2f78b36973c031fe1aea33c42f789.png";